import { DateTime } from 'luxon';

export const getLastUpdatedFromTimestamp = (timestamp?: string) => {
    if (timestamp) {
        const dt = DateTime.fromISO(timestamp, { zone: 'utc' });
        return dt.toFormat('HH:mm dd/MM/yy');
    }
};
